export default __webpack_public_path__ + "static/media/P941MANC3.3d04d2a7.pdf";